import CommuneRepository from '../../../../repositories/commune.repository';

require('./adresse.scss');

export default class AdresseComponent {
  constructor() {
    this.controller = AdresseController;
    this.template = require('./adresse.html');
    this.bindings = {
      prefix: '@',
      adresse: '<',
      parentForm: '<',
      onAdresseChange: '&'
    };
  }
}

// @ngInject
class AdresseController {
  constructor() {
    this.communes = {
      loading: false,
      data: []
    };
    this.communecps = {
      loading: false,
      data: []
    };
  }

  $onInit() {
    this.prefix = this.prefix ? this.prefix : '';
  }

  $onChanges(changes) {
    if (changes.adresse) {
      this.data = this.adresse ? this.adresse : {commune: null, codePostal: null};
      if (this.data.commune) {
        this.communes.data = [this.data.commune];
      }
    }
  }

  refreshCommunes (search) {
    if (!search) {
      return;
    }
    this.communes.loading = true;
    return CommuneRepository.searchCommune(search)
      .then((response) => {
        this.communes.data = [];
        let communes = response.data;
        for (let i = 0; i < communes.length; i++) {
          let commune =  communes[i];
          this.communes.data.push({codepostal: commune.codePostals[0] ? commune.codePostals[0].code : '',
            nom: commune.nom, numeroDep: commune.numeroDep, insee: commune.insee,
            id: commune.id, codePostals: commune.codePostals});
        }
      })
      .finally(() => this.communes.loading = false);
  }

  refreshCps (search) {
    if (!search) {
      return;
    }
    this.communecps.loading = true;
    return CommuneRepository.searchCodePostal(search)
      .then((response) => {
        this.communecps.data = [];
        let communes = response.data;
        for (let i = 0; i < communes.length; i++) {
          this.communecps.data.push({codepostal: search,nom: communes[i].nom, numeroDep: communes[i].numeroDep, insee: communes[i].insee,
                                    id: communes[i].id, codePostals: communes[i].codePostals});
        }
      })
      .finally(() => this.communecps.loading = false);
  }

  onCodePostalSelect ($item) {
    if ($item) {
      this.communes.data = [];
      this.communes.data.push($item);
      this.data.commune = $item;
    } else {
      this.data.codePostal = null;
    }
    this.onChange();
  }

  onCommuneSelect ($item) {
    if ($item) {
      this.communecps.data = [];
      for (let i = 0; i < $item.codePostals.length; i++) {
        this.communecps.data.push({codepostal: $item.codePostals[i].code, nom:  $item.nom, numeroDep:  $item.numeroDep, insee:  $item.insee,
                                  id:  $item.id, codePostals:  $item.codePostals});
      }
      this.data.codePostal = $item;
    }else {
      this.data.codePostal = null;
    }
    this.onChange();
  }

  onChange() {
    this.onAdresseChange({adresse: this.data});
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/components/adresse/adresse.component.js